<template>
  <p class="text-lg text center">
    <template v-if="project.userNeedsToBuyStorage">
      <template v-if="currentUser.isMember">This digitization project requires <strong>{{bytesNeeded}}</strong>, but you only have <strong>{{bytesAvailable}}</strong> available. <br>Buy more FOREVER Storage below.</template>
      <template v-else>To preserve this digitization project, you’ll need <strong>{{bytesNeeded}}</strong> of Permanent Storage.</template>
    </template>
    <template v-else><b>{{bytesNeeded}}</b> of your <b>{{bytesAvailable}}</b> permanent storage will be used.</template>
  </p>
</template>

<script setup>
import {formatBytes} from '~/utils/formatters.js';
  const props = defineProps({
    project: Object
  });

  const sessionStore = useSessionStore();
  const {currentUser} = storeToRefs(sessionStore);

  const bytesNeeded = computed(() => formatBytes(props.project.total_size_bytes));
  const bytesAvailable = computed(() => formatBytes(currentUser.value.storage_remaining));
</script>
